module.exports = __webpack_public_path__ + "img/spinner.ec1090ba.jpeg";